import Measurer from './Measurer';

class Measurement {
  constructor(map) {
    this.map = map;
    this.measurer = null;
  }

  onMouseMove(e) {
    const point = {
      x: e.absolutePointer.x,
      y: e.absolutePointer.y
    };

    if (this.measurer && !this.measurer.completed) {
      this.map.emit('measure:update', this.length());
      this.measurer.setEnd(point);
      this.map.canvas.requestRenderAll();
    }
  }

  onClick(e) {
    const point = {
      x: e.absolutePointer.x,
      y: e.absolutePointer.y
    };
    if (!this.measurer) {
      this.measurer = new Measurer({
        start: point,
        end: point,
        map: this.map
      });
    } else if (!this.measurer.completed) {
      this.measurer.setEnd(point);
      this.measurer.complete();
      this.map.emit('measure:complete', this.length());
    }
  }

  length() {
    if (this.measurer) {
      return this.measurer.length();
    }
    return -1;
  }

  clear() {
    if (this.measurer) {
      this.measurer.clear();
      this.measurer = null;
    }
  }
}

export default Measurement;
